// extracted by mini-css-extract-plugin
var _1 = "address__U76SF";
var _2 = "archive__rszWi";
var _3 = "first-line__tUKUg";
var _4 = "first-line-left__nOlqV";
var _5 = "first-line-right__TAySY";
var _6 = "form-summary__VgX83";
var _7 = "label__ACmpB";
var _8 = "logo__cFz8l";
var _9 = "print-header__BxrQR";
var _a = "print-header-info__HyewI";
var _b = "second-line__aUod2";
var _c = "value__wdWFw";
export { _1 as "address", _2 as "archive", _3 as "first-line", _4 as "first-line-left", _5 as "first-line-right", _6 as "form-summary", _7 as "label", _8 as "logo", _9 as "print-header", _a as "print-header-info", _b as "second-line", _c as "value" }
